// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"d4c2d574","369":"706dda59","623":"cedf19a0","815":"4a39fa42","827":"e4f0293e","895":"73436152"}[chunkId] + ".chunk.js";
};